








import Vue, { PropType } from "vue";

export interface BackButtonHolingParamsProps {
  baseUrl: string;
  params: any;
}

export interface BackButtonHolingParamsData {
  actionUrl: string;
}

export default Vue.extend({
  name: "vc-back-button-holding-prams",
  props: {
    baseUrl: {
      type: String as PropType<BackButtonHolingParamsProps["baseUrl"]>,
      default: ""
    },
    params: {
      type: Object as PropType<BackButtonHolingParamsProps["params"]>,
      default: () => ({})
    }
  },
  data(): BackButtonHolingParamsData {
    return {
      actionUrl: this.baseUrl
    };
  },
  mounted() {
    this.createUrl(this.params);
  },
  methods: {
    createUrl(params: any) {
      const objectKeys: Array<string> = Object.keys(params);

      if (objectKeys.length === 0) {
        return;
      }

      let queryParams: any = [];
      objectKeys.forEach(key => {
        queryParams.push(key + "=" + this.params[key]);
      });
      this.actionUrl = this.baseUrl + "?" + queryParams.join("&");
    }
  }
});
